export type GachaBuybackOfferStatus =
  | "preparing"
  | "loading"
  | "ready"
  | "error"
  | "ineligible"

export function getGachaBuybackOfferStatus({
  eligible,
  hasPrice,
  loading,
  failed,
  availabilitySettled,
}: {
  eligible: boolean | undefined
  hasPrice: boolean
  loading: boolean
  failed: boolean
  availabilitySettled: boolean
}): GachaBuybackOfferStatus {
  if (eligible === false) return "ineligible"
  if (hasPrice && eligible === true && !failed) return "ready"
  if (loading) return "loading"
  if (failed || (availabilitySettled && eligible === undefined)) return "error"
  return "loading"
}
